import styled from "styled-components";

export const Container = styled.div`

    /* display: flex;
    flex-direction: column;
    width: 100%;
    background-color: white;
    
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; */

`;

export const Loading = styled.div`

    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20vh;

    > div {
        border: 8px solid #f3f3f3; /* Light grey */
        border-top: 8px solid #3498db; /* Blue */
        border-radius: 50%;
        width: 30px;
        height: 30px;
        animation: spin 2s linear infinite;

        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    }
    

`;

export const Main = styled.main`

    max-width: 72rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: 16px;
    margin-bottom: 16px;

`;

export const TableContainer = styled.div`

    display: flex;
    align-items: center;
    justify-content: space-between;

`;

export const Table = styled.table`

    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
    font-size: 0.9em;
    border-radius: 8px 8px 0 0;
    overflow: hidden;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);

`;

export const TableHeader = styled.thead`

    text-align: left;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 1rem;
    padding-right: 1rem;
    font-weight: 500;
    color: black;

`;

export const TableHead = styled.th`

    padding: 12px 15px;

`;

export const TableHeadRow = styled.tr`

    background-color: #193553;
    color: #ffffff;
    text-align: left;
    font-weight: bold;

`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`

    border-bottom: 1px solid #dddddd;
    :nth-of-type(even) {
        background-color: #f3f3f3;
    }
    :last-of-type {
        border-bottom: 2px solid #193553;
    }

`;

export const TableCell = styled.td`

    padding: 12px 15px;

`;

export const FilterContainer = styled.div`

    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-right: 16px;

`;

export const FormContainer = styled.form`

    display: flex;
    gap: 1rem;
    align-items: center;

`;

export const FilterInputContainer = styled.div`
    display: flex; 
    padding-top: 0.375rem;
    padding-bottom: 0.375rem; 
    padding-left: 0.75rem;
    padding-right: 0.75rem; 
    gap: 0.375rem; 
    align-items: center; 
    border-radius: 9999px; 
    border-style: dashed; 
    font-size: 0.75rem;
    line-height: 1rem; 
    line-height: 1.25;

`;

export const FilterInput = styled.input`

    flex: 1 1 0%; 
    outline-style: hidden;
    border: none;
    background-color: transparent;

`;

export const FilterButton = styled.button`

    padding-top: 0.375rem;
    padding-bottom: 0.375rem; 
    padding-left: 0.625rem;
    padding-right: 0.625rem; 
    border-radius: 0.375rem; 
    border-width: 1px; 

`;